module.exports = __webpack_public_path__ + "assets/done_icon.15babe9e.svg";